<template>
    <v-container class="app-background-color pa-0" fill-height fluid>
        <v-row align="center" class="fill-height" justify="center" no-gutters>
            <v-col class="d-flex justify-center" cols="12">
                <v-row justify="center" no-gutters>
                    <v-avatar :height="maxWidth"
                              :width="maxWidth"
                              style="box-shadow: 0 0 0 5px rgba(255,255,255,0.2)"
                    >
                        <v-img alt="Fitt" contain max-width="120" src="@/assets/fitt_logo.svg"></v-img>
                    </v-avatar>
                    <page-heading class="mt-5" text="Mobile not supported"></page-heading>
                    <div class="text-center mt-3 mx-2 body-2">
                        This version of fitt does not support mobile devices.
                    </div>
                    <div class="text-center mx-2 body-2">
                        Please use a desktop computer with a modern browser
                        such as Chrome or Firefox.
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../PageHeading";

    export default {
        name: "mobile-not-supported",
        components: {
            PageHeading
        },
        computed: {
            maxWidth() {
                return innerWidth - 200;
            }
        }
    }
</script>

<style scoped>

</style>